import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
	ModulePermissionPayload,
	ModulePermissionAddPayload,
	ModulePermissionUpdatePayload
} from './module-permission.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ModulePermissionService {

	private token!: string;
	private httpOptions: any;

	private basePath = environment.interop.basePath;
	private getModulesDTUrl = this.basePath + environment.interop.platform.app.settings.modulePermission.getModulePermissionsDT;
	private storeModuleUrl = this.basePath + environment.interop.platform.app.settings.modulePermission.storeModulePermission;
	private putModuleUrl = this.basePath + environment.interop.platform.app.settings.modulePermission.putModulePermission;
	private deleteModuleUrl = this.basePath + environment.interop.platform.app.settings.modulePermission.deleteModulePermission;

	private getModulesUrl = this.basePath + environment.interop.platform.app.settings.modulePermission.getModulePermissions;
    private getPermissionsAuthLibUrl = this.basePath + environment.interop.platform.app.settings.modulePermission.getPermissionsAuthLib;
    private getPermissionsByModuleIdUrl = this.basePath + environment.interop.platform.app.settings.modulePermission.getPermissionsByModuleId;

	constructor(private http: HttpClient) { }

    getModules() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getModulesUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({ id: item.id, name: item.name }))
                ),
                catchError((error) => {
                    console.error('Error in getUsers:', error);
                    return throwError(error);
                })
            );
	}

	getModulesDT() {
		return this.http.get(this.getModulesDTUrl, this.httpOptions);
	}

	addModule(data: ModulePermissionAddPayload) {
		return this.http.post(this.storeModuleUrl, data, this.httpOptions);
	}

	updateModule(data: ModulePermissionUpdatePayload) {
		return this.http.put(this.putModuleUrl, data, this.httpOptions);
	}

	deleteModule(id: number) {
		return this.http.delete(this.deleteModuleUrl + id, this.httpOptions);
	}

	getPermissionsAuthLib(id: number) {
		return this.http.get(this.getPermissionsAuthLibUrl + id, this.httpOptions);
	}

	getPermissionsByModuleId(id: number) {
		return this.http.get(this.getPermissionsByModuleIdUrl + id, this.httpOptions);
	}

	setToken(token: string) {
		this.token = token;
		this.httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${this.token}`,
			}),
		};
	}
}
